import { ColDef, ITooltipParams, ValueFormatterParams } from 'ag-grid-enterprise';
import { filterParams } from 'features/Remittance/reportsListConfig';
import { formatDate } from 'utilities/dateFormatter';
import { WireType, WireValidationListResult, WireValidationRow } from './interfaces/wireValidation';

export const getPayeeOrBankName = (wireType?: string, payee?: string, bankName?: string): string =>
  (wireType === WireType.MORTGAGE_PAYOFF ? bankName ?? payee : payee) ?? '';

export const normalizeWireValidationRows = (results: WireValidationListResult[]): WireValidationRow[] =>
  (results ?? []).map(
    ({
      fileId,
      fileNumber,
      payee,
      bankName,
      wireType,
      wireAmount,
      wireValidationSummary,
      requestedByName,
      requestedDate,
    }) => ({
      fileId,
      fileNumber,
      payee,
      wireType,
      wireAmount,
      validationStatus: wireValidationSummary?.validationStatus ?? '',
      statusMessage: wireValidationSummary?.message,
      orderId: wireValidationSummary?.orderId ?? '',
      requestedByName,
      requestedDate,
      payeeOrBankName: getPayeeOrBankName(wireType, payee, bankName),
    }),
  );

const fmtDate = (p: ValueFormatterParams) => (p.value ? formatDate(p.value, '', 'custom', 'MM/dd/yyyy') ?? '' : '');

const fmtAmount = (p: ValueFormatterParams) => {
  const val = p.value;
  if (val == null) return '';
  return typeof val === 'number' ? val.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : val;
};

export const wireValidationColDefs: ColDef[] = [
  {
    headerName: 'Payee/Bank Name',
    field: 'payeeOrBankName',
    filter: 'agTextColumnFilter',
    minWidth: 180,
    flex: 1.2,
    cellRenderer: 'payeeRenderer',
  },
  {
    headerName: 'File Number',
    field: 'fileNumber',
    filter: 'agTextColumnFilter',
    minWidth: 140,
    flex: 1,
  },
  {
    headerName: 'Status',
    field: 'validationStatus',
    minWidth: 140,
    cellRenderer: 'verificationChip',
    tooltipValueGetter: (params: ITooltipParams) => {
      const message: string | undefined = params.data?.statusMessage;
      return message || null;
    },
  },
  {
    headerName: 'Amount',
    field: 'wireAmount',
    valueFormatter: fmtAmount,
    filter: 'agNumberColumnFilter',
    minWidth: 130,
    headerClass: 'ag-right-aligned-header',
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'Last Run',
    field: 'requestedDate',
    valueFormatter: fmtDate,
    minWidth: 190,
    filter: 'agDateColumnFilter',
    filterParams: filterParams,
    sort: 'desc',
  },
  {
    headerName: 'Requested By',
    field: 'requestedByName',
    filter: 'agTextColumnFilter',
    minWidth: 160,
  },
  {
    field: 'actions',
    headerName: '',
    cellRenderer: 'actionsRenderer',
    width: 90,
    minWidth: 90,
    filter: false,
    floatingFilter: false,
    pinned: 'right',
  },
];
